import styled from 'styled-components';
import { variant } from 'styled-system';

const Text = styled('p')(
  {
    color: 'inherit',
    margin: '0px',
    fontFamily: 'Overpass'
  },
  variant({
    variants: {
      h2: {
        fontWeight: '900',
        fontSize: '24px',
        lineHeight: '37px',
        color: '#212121'
      },
      h4: {
        fontWeight: '900',
        fontSize: '18px',
        lineHeight: '28px',
        color: '#444053'
      },
      h5: {
        fontWeight: '900',
        fontSize: '16px',
        lineHeight: '21px',
        color: '#444053'
      },
      h6: {
        fontWeight: 'bold',
        fontSize: '14px',
        lineHeight: '21px',
        color: '#444053'
      },
      caption: {
        fontWeight: 'bold',
        fontSize: '11px',
        lineHeight: '13px',
        color: '#444053'
      },
    }
  })
);

export default Text;
